export const contactInfo = {
  ContactEmail: 'info@sayma.net',
};
